module.exports = __webpack_public_path__ + "static/media/logo.e65d4480.png";